/**
 * Created by user on 2020/5/29.
 */

/**
 * 用來測試字串切割是否正確用的列表
 */
export const unsafeChinese = [

	'𠮷', '𠬠', '𡬶', '𫗭', '𣛙', '𢎐',

] as const;
